import { useState } from "react";
import Vector from "../assets/Vector.svg";
import _, { template } from "lodash";
import "./ContentResultManual.scss";

const ContentResultManual = ({ templateData, manualEntries, setManualEntries }) => {
  const goalShots = templateData?.data?.dynamic?.goalShots;
  const goals = goalShots?.filter(({ typeId }) => typeId === 16);
  const homeTeam = templateData?.event.home;
  const awayTeam = templateData?.event.away;

  const homeTeamId = homeTeam?.id;
  const awayTeamId = awayTeam?.id;

  const lineUp = templateData?.data?.dynamic?.lineUp;
  const homeLineUp = lineUp?.find((l) => l.contestantId === homeTeamId)?.player;
  const awayLineUp = lineUp?.find((l) => l.contestantId === awayTeamId)?.player;
  const homeGoals = goals
    .filter(goal => goal.contestantId === homeTeamId)
    .map(goal => {
      const player = homeLineUp.find(p => p.playerId === goal.playerId);
      const isPenalty = goal?.isPenalty;
      return {
        min: goal.timeMin?.toString() || '',
        name: (player?.shortLastName || goal.scorerName || '') + (isPenalty ? " (P)" : "") // fallback if player not found
      };
    });
  const awayGoals = goals
    .filter(goal => goal.contestantId === awayTeamId)
    .map(goal => {
      const player = awayLineUp.find(p => p.playerId === goal.playerId);
      const isPenalty = goal?.isPenalty;
      return {
        min: goal.timeMin?.toString() || '',
        name: (player?.shortLastName || goal.scorerName || '') + (isPenalty ? " (P)" : "")  // fallback if player not found
      };
    });

  // Initial score from data
  let _hScore = goals?.filter(goal => goal.contestantId === homeTeam.id)?.length ?? 0;
  let _aScore = goals?.filter(goal => goal.contestantId !== homeTeam.id)?.length ?? 0;

  if (manualEntries) {
    const scores = manualEntries.scores;
    _hScore = scores?.home ?? _hScore;
    _aScore = scores?.away ?? _aScore;
  }

  const [hScore, setHScore] = useState(_hScore);
  const [aScore, setAScore] = useState(_aScore);

  // Initialize team scores
  let initialHomeTeamScores = homeGoals.length > 0
    ? homeGoals
    : Array.from({ length: Math.max(_hScore, 5) }, () => ({ min: '', name: '' }));

  let initialAwayTeamScores = awayGoals.length > 0
    ? awayGoals
    : Array.from({ length: Math.max(_aScore, 5) }, () => ({ min: '', name: '' }));
  // // console.log(hScore, aScore)
  // let initialHomeTeamScores = Array.from({ length: _hScore > 4 ? _hScore : 5 }, () => ({
  //     min: '',
  //     name: ''
  // }));
  // if (manualEntries) {
  //     initialHomeTeamScores = manualEntries.players?.home;
  // }
  // const [homeTeamScores, setHomeTeamScores] = useState(() => initialHomeTeamScores);
  // let initialAwayTeamScores = Array.from({ length: _aScore > 4 ? _hScore : 5 }, () => ({
  //     min: '',
  //     name: ''
  // }));
  // if (manualEntries) {
  //     initialAwayTeamScores = manualEntries.players?.away;
  // }

  if (manualEntries) {
    initialHomeTeamScores = manualEntries.players?.home || initialHomeTeamScores;
    initialAwayTeamScores = manualEntries.players?.away || initialAwayTeamScores;
  }

  const [homeTeamScores, setHomeTeamScores] = useState(initialHomeTeamScores);
  const [awayTeamScores, setAwayTeamScores] = useState(initialAwayTeamScores);

  const onHValueChange = (e) => {
    const value = parseInt(e.target.value, 10);
    const newLength = Math.max(5, isNaN(value) ? 0 : value);
    setHScore(value);

    const updatedHomeScores = (() => {
      const current = [...homeTeamScores];
      if (newLength > current.length) {
        const toAdd = Array.from({ length: newLength - current.length }, () => ({ min: '', name: '' }));
        return [...current, ...toAdd];
      } else {
        return current.slice(0, newLength);
      }
    })();

    setHomeTeamScores(updatedHomeScores);
    setManualEntries({
      scores: {
        home: value,
        away: aScore
      },
      players: {
        home: updatedHomeScores,
        away: awayTeamScores
      }
    });
  };


  const onAValueChange = (e) => {
    const value = parseInt(e.target.value, 10);
    const newLength = Math.max(5, isNaN(value) ? 0 : value);
    setAScore(value);

    const updatedAwayScores = (() => {
      const current = [...awayTeamScores];
      if (newLength > current.length) {
        const toAdd = Array.from({ length: newLength - current.length }, () => ({ min: '', name: '' }));
        return [...current, ...toAdd];
      } else {
        return current.slice(0, newLength);
      }
    })();


    setAwayTeamScores(updatedAwayScores);
    setManualEntries({
      scores: {
        home: hScore,
        away: value
      },
      players: {
        home: homeTeamScores,
        away: updatedAwayScores
      }
    });
  };

  const onHPlayerChange = (index, min, name) => {
    const newHomeTeamScores = [...homeTeamScores];
    if (min !== null) newHomeTeamScores[index].min = min;
    if (name !== null) newHomeTeamScores[index].name = name;

    setHomeTeamScores(newHomeTeamScores);
    setManualEntries({
      scores: {
        home: hScore,
        away: aScore
      },
      players: {
        home: newHomeTeamScores,
        away: awayTeamScores
      }
    });
  };

  const onAPlayerChange = (index, min, name) => {
    const newAwayTeamScores = [...awayTeamScores];
    if (min !== null) newAwayTeamScores[index].min = min;
    if (name !== null) newAwayTeamScores[index].name = name;

    setAwayTeamScores(newAwayTeamScores);
    setManualEntries({
      scores: {
        home: hScore,
        away: aScore
      },
      players: {
        home: homeTeamScores,
        away: newAwayTeamScores
      }
    });
  };

  return (
    <div>
      <div className="content-tab">
        <div className="add-score-form">
          <div className="input-pair">
            <input
              type="number"
              className="half-input"
              value={hScore}
              onChange={onHValueChange}
            />
            <span className="separator">-</span>
            <input
              type="number"
              className="half-input"
              value={aScore}
              onChange={onAValueChange}
            />
          </div>
        </div>

        <div className="add-player-container">
          <div className="add-player team-home">
            {homeTeamScores.map((value, index) => {
              const isActive = index < hScore;
              return (
                <div className={`add-player-item ${!isActive ? 'inactive' : ''}`} key={index}>
                  <input
                    className="min"
                    placeholder="Min"
                    value={value.min}
                    onChange={(e) => isActive && onHPlayerChange(index, e.target.value, null)}
                    disabled={!isActive}
                  />
                  <input
                    className="name"
                    placeholder="Name"
                    value={value.name}
                    onChange={(e) => isActive && onHPlayerChange(index, null, e.target.value)}
                    disabled={!isActive}
                  />
                </div>
              );
            })}
          </div>

          <div className="add-player team-away">
            {awayTeamScores.map((value, index) => {
              const isActive = index < aScore;
              return (
                <div className={`add-player-item ${!isActive ? 'inactive' : ''}`} key={index}>
                  <input
                    className="min"
                    placeholder="Min"
                    value={value.min}
                    onChange={(e) => isActive && onAPlayerChange(index, e.target.value, null)}
                    disabled={!isActive}
                  />
                  <input
                    className="name"
                    placeholder="Name"
                    value={value.name}
                    onChange={(e) => isActive && onAPlayerChange(index, null, e.target.value)}
                    disabled={!isActive}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentResultManual;